import { dailyService } from "../services/soar";
import { toast } from "react-toastify";
const applicationId =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
    : "58990f83-8566-4ba8-b4b5-584a64e4cba1";
export async function addDailyService(
  clientProgram,
  bedAssignment,
  residenceName,
  date,
  serviceStatus
) {
  console.log("Daily Service Params", {
    clientProgram: clientProgram,
    bedAssignment: bedAssignment,
    residenceName: residenceName,
    date: date,
    serviceStatus: serviceStatus,
  });
  if (clientProgram && bedAssignment && date) {
    const response = await dailyService({
      command: "insert",
      application: applicationId,
      client: clientProgram.client.id,
      clientName: clientProgram.client.name,
      clientMpi: clientProgram.client.mpi,
      birthDate: clientProgram.client.dob,
      clientProgram: clientProgram.id,
      clientProgramName: clientProgram.name,
      program: clientProgram.unit.id,
      programName: clientProgram.unit.name,
      residence: bedAssignment.bed.residence,
      residenceName: residenceName,
      bed: bedAssignment.bed.id,
      bedName: bedAssignment.bed.name,
      bedClientAssignment: bedAssignment.id,
      serviceConfiguration: bedAssignment.serviceConfiguration,
      serviceConfigurationName: bedAssignment.serviceConfigurationName,
      serviceDate: date,
      serviceStatus: serviceStatus,
      residenceTier: 1,
      billingRuleSubset: {},
      billingRuleRevenue: 0.0,
      billingRuleReimbursement: 0.0,
      glCode: "",
    });
    return response;
  } else {
    toast.error("Missing required parameters.");
  }
}
